import React from 'react';
import PropTypes from 'prop-types';
import { isResponsiveImageType } from '../utilities/images';
import {
	setBackgroundStyles,
	setBackgroundClassNames
} from '../utilities/background';

const Background = (props) => {
	const {
		showImage,
		imageLocation,
		imageUrl,
		imagePosition,
		imageSize,
		backgroundColor,
		backgroundGradient,
		backgroundRepeat,
		backgroundTransitionProperty,
		backgroundTransitionTimingFunction,
		backgroundTransitionDuration,
		backgroundWidthMultiplier,
		foregroundImageCircle,
		foregroundImageHeight,
		foregroundImageWidth,
		foregroundImageMargin,
		foregroundImagePadding,
		foregroundImageAlignment
	} = props;

	const imageRef = React.useRef(null);
	const [backgroundImage, setBackgroundImage] = React.useState(
		'/static/images/blank.gif'
	);

	const hasResponsiveImage = isResponsiveImageType(imageUrl, imageLocation);
	const hasBackground =
		showImage === false &&
		imageLocation !== 'foreground' &&
		(backgroundColor !== '' || backgroundGradient !== '');

	const updateBackgroundImage = () => {
		const imageSrc = imageRef.current.currentSrc || imageRef.current.src;
		setBackgroundImage(imageSrc);
	};

	React.useEffect(() => {
		const image = imageRef.current;
		if (image?.complete) {
			updateBackgroundImage?.();
		}
	}, [imageRef]);

	if (showImage || hasBackground) {
		return (
			<div
				className={setBackgroundClassNames(
					imageLocation,
					foregroundImageCircle,
					foregroundImageMargin,
					foregroundImagePadding,
					foregroundImageAlignment,
					backgroundColor,
					backgroundTransitionProperty,
					backgroundTransitionTimingFunction,
					backgroundTransitionDuration
				)}
				style={setBackgroundStyles(
					showImage,
					imageLocation,
					imageUrl,
					imagePosition,
					imageSize,
					backgroundGradient,
					backgroundRepeat,
					foregroundImageHeight,
					foregroundImageWidth,
					hasResponsiveImage,
					backgroundImage
				)}
				data-testid="background"
			>
				{hasResponsiveImage && (
					<img
						alt=""
						hidden
						ref={imageRef}
						role="presentation"
						data-src={imageUrl}
						onLoad={updateBackgroundImage}
						data-width-multiplier={backgroundWidthMultiplier}
						className="lazy-image dynamic-resize responsive-image d-none"
					/>
				)}
			</div>
		);
	}
	return null;
};

Background.defaultProps = {
	imageLocation: '',
	imageUrl: '',
	imagePosition: '',
	imageSize: '',
	backgroundColor: '',
	backgroundGradient: '',
	backgroundRepeat: '',
	backgroundTransitionProperty: '',
	backgroundTransitionTimingFunction: '',
	backgroundTransitionDuration: '',
	backgroundWidthMultiplier: '1',
	foregroundImageCircle: false,
	foregroundImageHeight: 0,
	foregroundImageWidth: 0,
	foregroundImageMargin: '',
	foregroundImagePadding: '',
	foregroundImageAlignment: ''
};

Background.propTypes = {
	showImage: PropTypes.bool.isRequired,
	imageLocation: PropTypes.string,
	imageUrl: PropTypes.string,
	imagePosition: PropTypes.string,
	imageSize: PropTypes.string,
	backgroundColor: PropTypes.string,
	backgroundGradient: PropTypes.string,
	backgroundRepeat: PropTypes.string,
	backgroundTransitionProperty: PropTypes.string,
	backgroundTransitionTimingFunction: PropTypes.string,
	backgroundTransitionDuration: PropTypes.string,
	backgroundWidthMultiplier: PropTypes.string,
	foregroundImageCircle: PropTypes.bool,
	foregroundImageHeight: PropTypes.number,
	foregroundImageWidth: PropTypes.number,
	foregroundImageMargin: PropTypes.string,
	foregroundImagePadding: PropTypes.string,
	foregroundImageAlignment: PropTypes.string
};

export default Background;
